import { calculateISR } from "./IsrUtil";
import { calculateIMSSForPeriod } from "./ImssUtil";

// calcular nomina
const normalHourLimit = 46;
const overtimeHourLimit = 12;
export const calculateWeeklyPay = (ms, salary) => {
  const hours = ms / 3600000;

  const normal = Math.min(hours, 48);
  const extra = Math.min(Math.max(hours - normalHourLimit, 0), overtimeHourLimit);
  const triple = Math.max(hours - (normalHourLimit + overtimeHourLimit), 0);

  const pay =
    normal * salary +
    extra * salary * 2 +
    triple * salary * 3;

  return { hours, normal, extra, triple, pay };
};

export const calculateHourlyPay = (salary) => {
  return salary / 30 / 8; // Asumiendo 30 días al mes y 8 horas al día
};

/**
 * Calcular nómina básica (desglose de horas trabajadas y pago bruto)
 * Reglas de tiempo extra para guardias (México simplificado): 48 h normales, 9 h dobles, horas posteriores a 57 h al triple
 */
export const calculatePayroll = (weekMs, hourlyRate) => {
  const hours = weekMs / 3600000;

  // Reglas de tiempo extra para guardias (México simplificado)
  const normalHours = Math.min(hours, 46);
  const extraHours = Math.min(Math.max(hours - normalHours, 0), 12);
  const tripleHours = Math.max(hours - (normalHours + extraHours), 0);

  const normalPay = normalHours * hourlyRate;
  const doublePay = extraHours * hourlyRate * 2;
  const triplePay = tripleHours * hourlyRate * 3;

  const gross = normalPay + doublePay + triplePay;

  return {
    hours,
    normalHours,
    extraHours,
    tripleHours,
    normalPay,
    doublePay,
    triplePay,
    gross,
  };
};

/**
 * Calcular la nómina completa con impuestos y deducciones
 * @param {number} weekMs - Tiempo trabajado en milisegundos
 * @param {number} hourlySalary - Tarifa por hora
 * @param {string} payPeriod - Periodo de pago: "weekly", "biweekly" o "monthly"
 * @returns {object} Desglose completo de nómina con impuestos, deducciones y pago neto
 */
export const calculateCompletePayroll = (weekMs, hourlySalary, payPeriod = "weekly") => {
  // Calcular la nómina básica
  const payroll = calculatePayroll(weekMs, hourlySalary);

  // Calcular impuestos y deducciones
  const tax = calculateISR(payroll.gross, payPeriod);
  const imss = calculateIMSSForPeriod(payroll.gross, payPeriod);

  // Calcular el pago neto
  const net = payroll.gross - tax.isr - imss.imss;

  return {
    ...payroll,
    tax,
    imss,
    net,
  };
};